<section aria-labelledby="ctas-title" class="bg-white">
    <div class="news">
        <div class="news__header">
            <h3 class="typography-title-s">{{ 'home.my_potential_customers' | translate }}</h3>
        </div>
        <div *ngIf="leadsStats" class="gap-4 grid grid-cols-1 sm:grid-cols-12 overflow-hidden p-4">
            <article
                class="sm:col-span-12 lg:col-span-3 group relative p-4 flex flex-col justify-between transition-all duration-200 ease-out background-light-00">
                <div class="flex flex-col">
                    <span class="typography-title-xxl"> {{ leadsStats.newCustomers }} </span>
                    <span class="typography-body-m">
                        {{ 'home.new_potential_customers' | translate }}
                    </span>
                </div>

                <!-- Link -->
                <div class="mt-6">
                    <app-button [primary]="true" class="w-full" (click)="goToLeads()">
                        <div class="flex items-center">
                            {{ 'home.update' | translate }}
                        </div>
                    </app-button>
                </div>
            </article>
            <article
                class="sm:col-span-12 lg:col-span-3 group relative p-4 flex flex-col justify-between transition-all duration-200 ease-out background-light-00">
                <div class="flex flex-col">
                    <span class="typography-title-xxl"> {{ leadsStats.unconfirmed }} </span>
                    <span class="typography-body-m">
                        {{ 'home.not_confirmed' | translate }}
                    </span>
                </div>

                <!-- Link -->
                <div class="mt-6">
                    <app-button [secondary]="true" class="w-full" (click)="goToLeads()">
                        <div class="flex items-center">
                            {{ 'common.buttons.confirm' | translate }}
                        </div>
                    </app-button>
                </div>
            </article>
            <article
                class="sm:col-span-12 lg:col-span-3 group relative p-4 flex flex-col justify-between transition-all duration-200 ease-out background-light-00">
                <div class="flex flex-col">
                    <span class="typography-title-xxl"> {{ leadsStats.oppInProgress }} </span>
                    <span class="typography-body-m">
                        {{ 'home.in_process_leads' | translate }}
                    </span>
                </div>

                <!-- Link -->
                <div class="mt-6">
                    <app-button [secondary]="true" class="w-full" (click)="goToLeads()">
                        <div class="flex items-center">
                            {{ 'my_claims.in_progress' | translate }}
                        </div>
                    </app-button>
                </div>
            </article>
            <article
                class="sm:col-span-12 lg:col-span-3 group relative p-4 flex flex-col justify-between transition-all duration-200 ease-out background-light-00">
                <div class="flex flex-col">
                    <span class="typography-title-xxl"> {{ leadsStats.almostComplete }} </span>
                    <span class="typography-body-m">
                        {{ 'home.almost_complete' | translate }}
                    </span>
                </div>

                <!-- Link -->
                <div class="mt-6">
                    <app-button [secondary]="true" class="w-full" (click)="goToLeads()">
                        <div class="flex items-center">
                            {{ 'home.verify' | translate }}
                        </div>
                    </app-button>
                </div>
            </article>
        </div>
    </div>
</section>
